/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Spinner } from "reactstrap";
import { serviceGetChatsPage, serviceGetFilterChat, servicePutChat } from "services/chats";
import { servicePutTickets } from "services/tickets";
import SimpleBar from "simplebar-react";
import { Button, Icon } from "../../../components/Component";
import { ChatContext } from "./ChatContext";
import { ListFilterMessage } from "./ChatFilterMessage";
import { ChatItemSide } from "./partials/ChatItemSide";

export const ChatAsideBody = ({
  cookies,
  onInputChange,
  setCheckedTag,
  isModalTagAssignOpen,
  setIsModalTagAssignOpen,
  afterCursorChat,
  setAfterCursorChat,
  filterTab,
  isSearch,
  afterCursorSearchedMessage,
  setAfterCursorSearchedMessage,
  searchText,
  isLoading,
  status,
  filterTag,
  setContextMessage,
  roleFunctions,
  filterUserId,
  filterUserName,
  filterCampaign,
  filterDepartment,
  filterDate,
}) => {
  // Initiate Global State Context
  const {
    chatListState,
    chatListIdState,
    selectedIdState,
    filteredMessageListState,
    filteredChatListState,
    textFilterState,
  } = useContext(ChatContext);
  const [chatList, setChatList] = chatListState;
  const [, setChatIdList] = chatListIdState;
  const [, setSelectedId] = selectedIdState;
  const [filteredChatList, setFilteredChatList] = filteredChatListState;
  const [filteredMessageList, setFilteredMessageList] = filteredMessageListState;
  const [textFilter] = textFilterState;

  const [chatListSide, setChatListSide] = useState([]);

  const [ids, setIds] = useState([]);
  const [isLoadMoreChat, setLoadMoreChat] = useState(false);

  // Re-sort when chatList changes (e.g., real-time socket updates with new messages)
  // This ensures chats with newest messages bubble to the top
  useEffect(() => {
    if (textFilter !== "") {
      // Sort filtered chat list berdasarkan timestamp lastMessage (descending)
      const sortedChats = [...filteredChatList].sort((a, b) => {
        const timeA = a?.lastMessage?.timestamp
          ? typeof a.lastMessage.timestamp === "string"
            ? parseInt(a.lastMessage.timestamp)
            : a.lastMessage.timestamp
          : new Date(a?.lastMessage?.createdAt || a?.createdAt || 0).getTime();
        const timeB = b?.lastMessage?.timestamp
          ? typeof b.lastMessage.timestamp === "string"
            ? parseInt(b.lastMessage.timestamp)
            : b.lastMessage.timestamp
          : new Date(b?.lastMessage?.createdAt || b?.createdAt || 0).getTime();
        return timeB - timeA;
      });
      setChatListSide(sortedChats);
    } else {
      // Sort chat list berdasarkan timestamp lastMessage (descending)
      const sortedChats = [...chatList].sort((a, b) => {
        const timeA = a?.lastMessage?.timestamp
          ? typeof a.lastMessage.timestamp === "string"
            ? parseInt(a.lastMessage.timestamp)
            : a.lastMessage.timestamp
          : new Date(a?.lastMessage?.createdAt || a?.createdAt || 0).getTime();
        const timeB = b?.lastMessage?.timestamp
          ? typeof b.lastMessage.timestamp === "string"
            ? parseInt(b.lastMessage.timestamp)
            : b.lastMessage.timestamp
          : new Date(b?.lastMessage?.createdAt || b?.createdAt || 0).getTime();
        return timeB - timeA;
      });
      setChatListSide(sortedChats);
    }
  }, [filteredChatList, chatList, textFilter]);

  useEffect(() => {
    if (ids.length) {
      setChatIdList([...ids]);
    }
  }, [ids, setChatIdList]);

  const loadMoreChats = useCallback(async () => {
    if (!afterCursorChat?.hasNextPage) {
      setLoadMoreChat(false);
      return;
    }
    const responseGetChats = await serviceGetChatsPage(
      cookies.SIDikey,
      cookies.id,
      cookies.departmentIds, // FIXED: Changed from departmentId to departmentIds (plural)
      status,
      filterTag.toString(),
      afterCursorChat?.page + 1,
      roleFunctions,
      cookies.role.name,
      filterUserId,
      filterCampaign.toString(),
      "",
      filterDepartment.toString(),
      filterDate?.dateFrom ? filterDate.dateFrom.toISOString() : "",
      filterDate?.dateTo ? filterDate.dateTo.toISOString() : "",
    );

    console.log("loadmore", filterUserId, responseGetChats);
    if (new RegExp(/20+/).test(responseGetChats.status)) {
      const data = responseGetChats.data.data;

      const metaData = responseGetChats.data.meta;
      setAfterCursorChat(metaData);

      // Append paginated data (backend already sorted consistently across pages)
      setChatListSide((chat) => [...chat, ...data]);
      setChatList((chat) => [...chat, ...data]);

      if (filteredChatList && filteredChatList.length > 0) {
        setFilteredChatList((chat) => [...chat, ...data]);
      }
    }

    setLoadMoreChat(false);
    // }
  }, [
    afterCursorChat?.page,
    cookies.SIDikey,
    cookies.departmentIds, // FIXED: Changed from departmentId to departmentIds
    cookies.id,
    filterTag,
    filterCampaign,
    filterDepartment,
    filterDate,
    roleFunctions,
    setAfterCursorChat,
    setChatList,
    status,
    filterUserId,
  ]);

  const loadMoreSearchedMessage = async (e) => {
    if (afterCursorSearchedMessage?.hasNextPage) {
      const responseGetMessages = await serviceGetFilterChat(
        cookies.SIDikey,
        cookies.role.name,
        searchText,
        cookies.id,
        afterCursorSearchedMessage.page + 1,
        cookies.departmentId,
        roleFunctions,
        status,
        filterUserId,
      );

      if (new RegExp(/20+/).test(responseGetMessages.status)) {
        const messageData = responseGetMessages.data.messages.data;
        const chatData = responseGetMessages.data.chats.data;

        // Append search results (backend already sorted)
        setFilteredChatList((filteredChatList) => [...filteredChatList, ...chatData]);

        setFilteredMessageList((filteredMessageList) => [...filteredMessageList, ...messageData]);
        setAfterCursorSearchedMessage(responseGetMessages.data.messages.meta);
      } else {
        console.log("Error get Messages from DB", responseGetMessages);
      }
    }
  };
  const handleClickChat = async (e, item) => {
    let currentStatusObj = {};
    let currentStatus = "";
    let currentTicketStatusObj = null;

    setSelectedId(item.id);

    // currentStatus = 'UNOPENED' ? "OPENED" : item.status;
    switch (cookies.role.name) {
      case "SALES":
        currentStatus = item.status;
        currentStatusObj = { status: item.status === "UNOPENED" ? "OPENED" : item.status, unreadCount: 0 };
        if (item.userId === cookies.id) {
          // jika chat milik dirinya
          currentTicketStatusObj = { status: item.status === "UNOPENED" ? "OPENED" : item.status };
        }
        break;
      case "CS":
        currentStatus = item.csStatus;
        currentStatusObj = { csStatus: item.csStatus === "UNOPENED" ? "OPENED" : item.csStatus, unreadCountCs: 0 };
        if (item.userId === cookies.id) {
          // jika chat milik dirinya
          currentTicketStatusObj = { status: item.csStatus === "UNOPENED" ? "OPENED" : item.csStatus };
        }
        break;
      case "SUPER ADMIN":
        currentStatus = item.superStatus;
        currentStatusObj = {
          superStatus: item.superStatus === "UNOPENED" ? "OPENED" : item.superStatus,
          unreadCountSuper: 0,
        };
        break;
      case "HEAD":
        currentStatus = item.headStatus;
        currentStatusObj = {
          headStatus: item.headStatus === "UNOPENED" ? "OPENED" : item.headStatus,
          unreadCountHead: 0,
        };
        break;
      case "AUDITOR":
        currentStatus = item.auditorStatus;
        currentStatusObj = {
          auditorStatus: item.auditorStatus === "UNOPENED" ? "OPENED" : item.auditorStatus,
          unreadCountAuditor: 0,
        };
        break;
      case "SYSTEM ADMIN":
        currentStatus = item.sysAdminStatus;
        currentStatusObj = {
          sysAdminStatus: item.sysAdminStatus === "UNOPENED" ? "OPENED" : item.sysAdminStatus,
          unreadCountSysAdmin: 0,
        };
        item.sysAdminStatus = currentStatusObj.sysAdminStatus;
        break;
      default:
        currentStatus = item.adminStatus;
        currentStatusObj = {
          adminStatus: item.adminStatus === "UNOPENED" ? "OPENED" : item.adminStatus,
          unreadCountAdmin: 0,
        };
        break;
    }

    currentStatusObj.updatedAt = item.updatedAt;

    // if (!roleFunctions.includes('View_Chatbot')) {
    if (true) {
      await servicePutChat(cookies.SIDikey, item.id, { ...currentStatusObj });
      // if (currentStatus === "UNOPENED") {
      // }

      if (currentTicketStatusObj) {
        // jika ini dari cs atau sales, ticket harus di update
        // if(currentTicketStatusObj && currentTicketStatusObj.status !== item.tickets[0].status){ // jika ini dari cs atau sales, ticket harus di update
        //console.log('iya ini dirubah');

        if (item.tickets && item.tickets.length > 0) {
          await servicePutTickets(item.tickets[0].id, cookies.SIDikey, { ...currentTicketStatusObj });
          item.tickets[0].status = currentTicketStatusObj.status;
        }

        // const localChats = [...chatList];
        const fIndex = chatListSide.findIndex((el) => el.id === item.id);
        //console.log(fIndex)

        if (fIndex !== -1) {
          const oneChat = { ...chatListSide[fIndex], ...currentStatusObj };
          //console.log(oneChat)
          chatListSide[fIndex] = oneChat;
        }

        // //console.log(localChats[fIndex])
        // setChatList([...localChats]);
      }
    } else {
      if (currentStatus === "UNOPENED") {
        await servicePutChat(cookies.SIDikey, item.id, { ...currentStatusObj });
      }
    }
  };

  const scrollRef = useRef();

  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef.current?.scrollTop + scrollRef.current?.clientHeight >= scrollRef.current?.scrollHeight - 1) {
        if (!isLoadMoreChat) {
          setLoadMoreChat(true);
          loadMoreChats();
        }
        //isLoadMoreChat === false && loadMoreChats();
      }
    };

    scrollRef.current?.addEventListener("scroll", handleScroll);

    return () => {
      scrollRef.current?.removeEventListener("scroll", handleScroll);
    };
  }, [isLoadMoreChat, loadMoreChats]);

  return (
    <SimpleBar className="nk-chat-aside-body" id="chat-list" scrollableNodeProps={{ ref: scrollRef }}>
      <div className="nk-chat-list">
        <h6 className="title overline-title-alt">
          {filterTab} {filterUserName ? `(${filterUserName})` : ""}
        </h6>

        <ul className="chat-list">
          {isLoading ? (
            <div className="d-flex justify-content-center align-item-strecth">
              <Spinner animation="border" role="status" color="blue" />
            </div>
          ) : chatListSide.length !== 0 ? (
            chatListSide.map((item, idx) => {
              let currentItemStatus = "";
              switch (cookies.role.name) {
                case "SALES":
                  currentItemStatus = item.status;
                  break;
                case "CS":
                  currentItemStatus = item.csStatus;
                  break;
                case "SUPER ADMIN":
                  currentItemStatus = item.superStatus;
                  break;
                case "HEAD":
                  currentItemStatus = item.headStatus;
                  break;
                case "ADMIN":
                  currentItemStatus = item.adminStatus;
                  break;
                case "AUDITOR":
                  currentItemStatus = item.auditorStatus;
                  break;
                case "SYSTEM ADMIN":
                  currentItemStatus = item.sysAdminStatus;
                  break;
                default:
                  currentItemStatus = item.adminStatus;
                  break;
              }

              return (
                !item.group && (
                  <div key={idx} className="d-flex" onClick={(e) => handleClickChat(e, item)}>
                    {isModalTagAssignOpen && (
                      <></>
                      // <input
                      //   type="checkbox"
                      //   onChange={(e) => handleChangeInput(e, item)}
                      //   style={{ marginRight: "8px" }}
                      //   checked={ids.some((item2) => item2 === item.id)}
                      // />
                    )}
                    <ChatItemSide
                      item={item}
                      setIsModalTagAssignOpen={setIsModalTagAssignOpen}
                      setIds={setIds}
                      currentStatus={currentItemStatus}
                    />
                  </div>
                )
              );
            })
          ) : (
            <p className="m-3"></p>
          )}
          <>
            {afterCursorChat?.hasNextPage && afterCursorChat?.hasNextPage && !isSearch ? (
              <div className="d-flex justify-content-center mt-2 mb-3">
                <Button outline color="light" size="sm">
                  {isLoadMoreChat ? (
                    <Spinner></Spinner>
                  ) : (
                    <div className="mb-1 mt-1">
                      <span>Load More Chats</span>
                      <Icon name="reload-alt" />
                    </div>
                  )}
                </Button>
              </div>
            ) : (
              <></>
            )}
          </>
        </ul>

        <ListFilterMessage
          cookies={cookies}
          isSearch={isSearch}
          result={filteredMessageList}
          searchText={searchText}
          setContextMessage={setContextMessage}
        />
        {afterCursorSearchedMessage?.hasNextPage && isSearch && false ? (
          <div className="d-flex justify-content-center mb-2">
            <Button outline color="light" size="sm" onClick={(e) => loadMoreSearchedMessage(e)}>
              <span>Load More Message</span>
              <Icon name="reload-alt" />
            </Button>
          </div>
        ) : (
          <></>
        )}
      </div>
    </SimpleBar>
  );
};
